export default __webpack_public_path__ + "static/media/card-project4.2c20acb1.jpg";